<template>
    <div class="product--body product--body--item">
        <div class="col-12 d-flex align-items-center">
            <h3 class="pl-2 product--body--description flex--weight--1">
                {{ item.person }}
                <small v-if="item.pur_type != 'CUPO'" class="d-block">
                    {{ item.unit_price | currency}}
                    <span class="line-through rack--price" v-if="parseFloat(item.rack_price)">{{ item.rack_price | currency}}</span>
                </small>
                <small v-if="item.pur_type == 'CUPO'" class="d-block">
                    {{ item.grouped_price | currency}}
                    <span class="line-through rack--price" v-if="parseFloat(item.rack_price)">{{ groupedRackPrice | currency}}</span>
                </small>
                <small v-if="item.has_stock">
                    Quedan {{ item.stock }} cupos disponibles
                </small>
            </h3>

            <div class="col mt-3 mb-3 text-right d-flex no-wrap">
                <button class="product--body--minus--button" @click="decrease(item, 'ticket')">
                    <icon-base :view-box-height="24"
                               :view-box-width="24"
                               :height="25"
                               :width="25"
                               :min-height="88.8"
                               :min-width="-87"
                               :icon-color="iconColor">
                        <minus-icon/>
                    </icon-base>
                </button>
                <span class="product--body--quantity">{{ item.quantity }}</span>
                <button class="product--body--plus--button" @click="increase(item, 'ticket')">
                    <icon-base :view-box-height="24"
                               :view-box-width="24"
                               :height="25"
                               :width="25"
                               :min-height="89"
                               :min-width="-87"
                               :icon-color="iconColor">
                        <plus-icon/>
                    </icon-base>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true
            },
            increase: {
                type: Function,
                required: true,
            },
            decrease: {
                type: Function,
                required: true
            },
            iconColor: {
                type: String,
                default() {
                    return '#166ba6';
                }
            }
        },
        computed: {
            groupedRackPrice(){
                if(parseFloat(this.item.rack_price)){
                    return this.item.voucher_generation * this.item.rack_price;
                }
                return undefined;
            }
        },
        data() {
            return {
                item: this.data
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Product.vue